import React, { useEffect, useRef, useState } from 'react';

import { ReactComponent as Close } from '../../images/icons/close.svg';
import { PrimaryLink } from '../Common/Links';
import { checkForActiveHunt } from './helpers';
import * as styles from './SentimentModal.module.scss';

const SentimentModal = ({ isOpen, setShowModal, sentiment }) => {
  const [isActiveHunt, setIsActiveHunt] = useState(false);
  const dialogRef = useRef(null);
  const messages = {
    delight: { image: `/images/scavenger-hunt/delight-animated.gif`, copy: `Delight Found!` },
    rage: { image: `/images/scavenger-hunt/rage-animated.gif`, copy: `Rage Found!` },
    mischief: {
      image: `/images/scavenger-hunt/mischief-animated.gif`,
      copy: `Mischief Found!`,
    },
    agent_ai: { image: `/images/scavenger-hunt/agent_ai-animated.gif`, copy: `Agent AI Found!` },
  };

  useEffect(() => {
    checkForActiveHunt(setIsActiveHunt);
  }, []);

  const closeModal = () => {
    dialogRef.current?.close();
    setShowModal(false);
  };

  useEffect(() => {
    if (isOpen) {
      const scrollY = window.scrollY;
      dialogRef.current?.showModal();
      window.scrollTo({ top: scrollY });
    } else {
      closeModal();
    }
  }, [isOpen]);

  return isActiveHunt ? (
    <dialog ref={dialogRef} className={styles.modal} onClose={closeModal}>
      <button onClick={closeModal} className={styles.close} aria-label="Close modal">
        <Close />
      </button>
      <figure>
        <img src={messages[sentiment].image} alt={messages[sentiment]} className={styles.sentiment} />
        <figcaption className={styles[sentiment]}>{messages[sentiment].copy}</figcaption>
      </figure>
      <PrimaryLink
        label="Continue the hunt"
        isButton={true}
        className={styles.button}
        url={`/scavenger-hunt/?found=${sentiment}`}
      />
    </dialog>
  ) : null;
};

export default SentimentModal;
